import { WprValueMapSetter } from '../../../wpr-framework/model/WprValueMapSetter';
import { WprValueMap } from '../../../wpr-framework/model/WprValueMap';

/**
 * 都道府県名バリューマップ
 */
export class PrefecturesValueMap {
	// static メソッド  --------------------------------------------------------
	/**
   * ValueMap設定処理
   * @param vmSetter ValueMapセッター
   */
	public static addValueMap(vmSetter: WprValueMapSetter): void {
		const vm = new WprValueMap();
		vm.addValue('北海道', '北海道');
		vm.addValue('青森県', '青森県');
		vm.addValue('岩手県', '岩手県');
		vm.addValue('宮城県', '宮城県');
		vm.addValue('秋田県', '秋田県');
		vm.addValue('山形県', '山形県');
		vm.addValue('福島県', '福島県');
		vm.addValue('茨城県', '茨城県');
		vm.addValue('栃木県', '栃木県');
		vm.addValue('群馬県', '群馬県');
		vm.addValue('埼玉県', '埼玉県');
		vm.addValue('千葉県', '千葉県');
		vm.addValue('東京都', '東京都');
		vm.addValue('神奈川県', '神奈川県');
		vm.addValue('新潟県', '新潟県');
		vm.addValue('富山県', '富山県');
		vm.addValue('石川県', '石川県');
		vm.addValue('福井県', '福井県');
		vm.addValue('山梨県', '山梨県');
		vm.addValue('長野県', '長野県');
		vm.addValue('岐阜県', '岐阜県');
		vm.addValue('静岡県', '静岡県');
		vm.addValue('愛知県', '愛知県');
		vm.addValue('三重県', '三重県');
		vm.addValue('滋賀県', '滋賀県');
		vm.addValue('京都府', '京都府');
		vm.addValue('大阪府', '大阪府');
		vm.addValue('兵庫県', '兵庫県');
		vm.addValue('奈良県', '奈良県');
		vm.addValue('和歌山県', '和歌山県');
		vm.addValue('鳥取県', '鳥取県');
		vm.addValue('島根県', '島根県');
		vm.addValue('岡山県', '岡山県');
		vm.addValue('広島県', '広島県');
		vm.addValue('山口県', '山口県');
		vm.addValue('徳島県', '徳島県');
		vm.addValue('香川県', '香川県');
		vm.addValue('愛媛県', '愛媛県');
		vm.addValue('高知県', '高知県');
		vm.addValue('福岡県', '福岡県');
		vm.addValue('佐賀県', '佐賀県');
		vm.addValue('長崎県', '長崎県');
		vm.addValue('熊本県', '熊本県');
		vm.addValue('大分県', '大分県');
		vm.addValue('宮崎県', '宮崎県');
		vm.addValue('鹿児島県', '鹿児島県');
		vm.addValue('沖縄県', '沖縄県');
		vmSetter.addValueMap('prefectures', vm);
	}
	// -------------------------------------------------------------------------
}